<template>
  <div>
    <simple-header />
    <router-view />
    <simple-footer />
  </div>
</template>

<script>
import { SimpleHeader, SimpleFooter } from '@/components'

export default {
  name: 'SimpleLayout',
  components: {
    SimpleHeader,
    SimpleFooter
  }
}
</script>

<style scoped></style>
